import { Injectable } from "@angular/core";
import { Location } from "@app/models";
import { BehaviorSubject, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { LocationService } from "./location.service";

@Injectable({
  providedIn: "root"
})
export class LocationsCacheService {
  private allLocations$ = new BehaviorSubject<Location[]>([]);

  constructor(private locationService: LocationService) {}

  getAllLocations(): Observable<Location[]> {
    if (this.allLocations$.value.length) {
      return this.allLocations$;
    }
    return this.locationService.getAll().pipe(tap((locations: Location[]) => this.allLocations$.next(locations)));
  }

  invalidateCache(): void {
    this.allLocations$.next([]);
  }
}
